import api from './api';

const BASE_PATH = '/live_challenges';

export const liveChallengesApi = {
  index: () => api.get(BASE_PATH),
  show: id => api.get(`${BASE_PATH}/${id}`),
  create: data => api.post(BASE_PATH, { live_challenge: data }),
  update: (id, data) => api.patch(`${BASE_PATH}/${id}`, { live_challenge: data }),
  destroy: id => api.delete(`${BASE_PATH}/${id}`),
  duplicate: id => api.post(`${BASE_PATH}/${id}/duplicate`),

  openLobby: id => api.post(`${BASE_PATH}/${id}/open_lobby`),
  start: id => api.post(`${BASE_PATH}/${id}/start`),
  backToLobby: id => api.post(`${BASE_PATH}/${id}/back_to_lobby`),
  revealQuestion: id => api.post(`${BASE_PATH}/${id}/reveal_question`),
  closeQuestion: id => api.post(`${BASE_PATH}/${id}/close_question`),
  finish: id => api.post(`${BASE_PATH}/${id}/finish`),

  join: accessCode => api.post(`${BASE_PATH}/join`, { access_code: accessCode }),
  answer: (id, alternativeId) => api.post(`${BASE_PATH}/${id}/answer`, { alternative_id: alternativeId }),
  leaderboard: (id, limit = 10) => api.get(`${BASE_PATH}/${id}/leaderboard`, { params: { limit } }),
  myScore: id => api.get(`${BASE_PATH}/${id}/my_score`),
  qrData: id => api.get(`${BASE_PATH}/${id}/qr_data`)
};
